import React from 'react';
import { useLocation } from 'react-router-dom';
import logoIcon from 'assets/common/icons/logo_l.png';
import { COPY_RIGHT } from 'shared/constants/ui';
import Sidebar from 'components/Sidebar';
import Navbar from 'components/Navbar';

import 'styles/layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const SIDEBAR_HEADER_HEIGHT = 60; // サイドバーのロゴ部分の高さ(px)と合わせる

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/manager/login';

  if (isLoginPage) {
    // ログイン画面はSidebar, Navbar, Footerを非表示
    return <main className="flex-1 min-h-screen bg-gray-50">{children}</main>;
  }

  return (
    <div className="flex w-full min-h-screen">
      {/* Sidebar (fixed) */}
      <aside className="fixed top-0 left-0 z-30 flex flex-col items-center w-64 h-screen bg-white border-r">
        <div
          className="flex items-center justify-center w-full border-b"
          style={{ height: SIDEBAR_HEADER_HEIGHT }}
        >
          <img className="object-contain h-10" src={logoIcon} alt="Goodrescue24" />
        </div>
        <div className="flex-1 w-full overflow-x-hidden overflow-y-auto scrollbar-hide">
          <Sidebar />
        </div>
      </aside>

      {/* Main area (with header fixed) */}
      <div className="flex flex-col flex-1 min-h-screen ml-64">
        {/* Header (fixed) */}
        <header
          className="fixed top-0 right-0 z-20 flex items-center justify-between px-4 bg-white border-b border-gray-200 left-64"
          style={{ height: SIDEBAR_HEADER_HEIGHT }}
        >
          {/* 空白スペース（左） */}
          <div className="flex-1" />
          {/* Navbar（右端） */}
          <div className="flex items-center">
            <Navbar />
          </div>
        </header>

        {/* Main Content */}
        <main
          className="flex-1 p-6 overflow-auto bg-gray-100 scrollbar-hide"
          style={{ marginTop: SIDEBAR_HEADER_HEIGHT }}
        >
          {children}
        </main>

        {/* Footer */}
        <footer className="flex items-center justify-center h-12 mt-auto bg-white border-t">
          <p className="text-xs text-center text-gray-400">
            &copy; {COPY_RIGHT}
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Layout;